






















import {
  Component,
  Vue,
  Prop
} from "@/shared/vuepack";
import { ExpenseSubmitLogItem } from "@/shared/types";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import moment from "moment-timezone";

@Component({})
export default class AccountHolderExpenseSubmission extends Vue {
  hsabExpenseStore = useHsabExpenseStore();

  @Prop()
  expenseSubmitLogItems: ExpenseSubmitLogItem[];

  @Prop()
  hsabExpenseId: number;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  truncateFileName (filename) {
    const maxLength = 20;
    const postfixCharacterCount = 7;
    if (filename.length > maxLength) {
      return filename.slice(0, maxLength - (postfixCharacterCount + 3)) + "..." +
          filename.slice(filename.length - postfixCharacterCount, filename.length);
    }
    return filename;
  }
  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "N/A";
    }
    return moment.utc(date).format("MM/D/YYYY hh:mma z");
  }
  payload = "";
  showModal = false;
  async openAttachment (expenseSubmitLogItem: ExpenseSubmitLogItem) {
    const args = { username: this.username, partnerId: this.partnerId };
    const contents = await this.hsabExpenseStore.GetSubmitLogByFileName(this.hsabExpenseId, expenseSubmitLogItem.fileName, args);
    if (contents) {
      this.showModal = true;
      this.payload = contents;
    }
  }

  listFields = [{
    key: "fileName",
    label: "File Name",
    thClass: "text-left small",
    tdClass: "small"
  },
  {
    key: "dateCreated",
    label: "Submission Date",
    thClass: "small",
    tdClass: "small"
  }];
}
